import { Flex, Space, Text } from '@mantine/core';
import { FC, ReactNode } from 'react';
import { ThemeText } from '../../../Atoms/ThemeText';

interface Props {
  title: string;
  description?: string;
  rightSection: ReactNode;
}

const ConfigOption: FC<Props> = ({ title, description, rightSection }) => (
  <Flex align="center" mt="md">
    <div style={{ flexGrow: 1 }}>
      <ThemeText weight="bolder">{title}</ThemeText>
      {description && (
        <Text size="xs" color="dimmed">
          {description}
        </Text>
      )}
    </div>
    <Space w="xl" />
    {rightSection}
  </Flex>
);

export default ConfigOption;
